import { CreditCard } from '@openeducation/pp-rn-shared-types';

export const getCvvMaxLength = (cardType?: CreditCard): number => {
  const isAmex = cardType === CreditCard.AMERICAN_EXPRESS;
  return isAmex ? 4 : 3;
};
